// TODO: This entire solution here needs to be done again from scratch. A unified error handling solution should be found and all intermediery steps of fetch should be abstracted in a lib.
// The req lib should only deal with API specific checks and transformations.
import * as requestUtils from './request';
import { isProd, useMockApi } from 'lta_config';

export const ApiMode = {
	Atos: 'ATOS',
	Lta: 'LTA',
	LtaError: 'LTA_ERROR_MODE'
};

export const urlEncode = (object = {}) =>
	Object.keys(object)
		.map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
		.join('&');

export const shouldUseDefaultEndpoint = (options) => isProd || useMockApi || !options.local;

export const buildEndpoint = (endpoint, options = {}) => {
	// TODO confirm why this is hard-coded
	const absoluteUrl = 'https://int.lta.org.uk/';
	return shouldUseDefaultEndpoint(options) ? endpoint : `${absoluteUrl}${endpoint}`;
};

export const request = (parameters, options = {}) => {
	const { processResponse = true, apiMode = ApiMode.Lta } = options;
	// As the auth is done via cookies, these are missing on localhost so we need to add them manually.
	// Fetch doesn't send any cookies with the request by default if its a different origin request.
	// So we need to set the credentials to `include`;
	const completeArguments = shouldUseDefaultEndpoint(options)
		? parameters.args
		: { ...parameters.args, credentials: 'omit' };

	// TODO: add header parameters
	return new Promise((resolve, reject) =>
		fetch(parameters.endpoint, completeArguments)
			.then((response) => {
				if (response.status > 400) reject(response);
				return response;
			})
			.then((response) => {
				if (processResponse === false) resolve(response);
				// TODO: We should leverage the browser APIs to return JSON.
				// I think this was done because some calls had invalid responses.
				return response.text();
			})
			// eslint-disable-next-line complexity
			.then((text) => {
				// eslint-disable-next-line promise/always-return
				try {
					const data = JSON.parse(text);

					// TODO: This is a can of worms. API responses should be unified.
					if (apiMode === ApiMode.Atos) {
						if (!data || (data && data.error && data.error.ErrorCode !== '0')) {
							reject(data || true);
						}
						// TODO: This is another can of worms. API responses should be unified.
						// We did this to support find a coach api calls.
					} else if (apiMode === ApiMode.LtaError) {
						if (!data || (data && data.error && data.error.HasError === true)) {
							reject(data || true);
						}
					} else {
						if (!data || (data && data.error)) {
							reject(data || true);
						}
					}

					resolve(data);
				} catch {
					resolve(text);
				}
			})
			.catch((error) => {
				reject(error);
			})
	);
};

const Request = {
	get: (endpoint, data, options = {}) => {
		const url = requestUtils.buildEndpoint(endpoint, options);
		const dataParameters = requestUtils.urlEncode(data);
		return requestUtils.request(
			{
				endpoint: `${url}${dataParameters ? `?${dataParameters}` : ''}`,
				args: {
					method: 'GET'
					// headers: isProd || useMockApi || !options.local ? {
					// 	'Access-Control-Allow-Origin': 'http://localhost:8080/'
					// } : ''
				}
			},
			options && { ...options.req }
		);
	},
	post: (endpoint, data, options = {}) => {
		const url = requestUtils.buildEndpoint(endpoint, options);
		return requestUtils.request(
			{
				endpoint: url,
				args: {
					method: 'POST',
					headers: {
						'Content-type': 'application/json'
					},
					body: JSON.stringify(data)
				}
			},
			options && { ...options.req }
		);
	},
	postFormData: (endpoint, data, options = {}) => {
		const url = requestUtils.buildEndpoint(endpoint, options);
		return requestUtils.request(
			{
				endpoint: url,
				args: {
					method: 'POST',
					body: data
				}
			},
			options && { ...options.req }
		);
	},
	put: (endpoint, data, options = {}) => {
		const url = requestUtils.buildEndpoint(endpoint, options);
		return requestUtils.request(
			{
				endpoint: url,
				args: {
					method: 'PUT',
					headers: {
						'Content-type': 'application/json'
					},
					body: JSON.stringify(data)
				}
			},
			options && { ...options.req }
		);
	},
	delete: (endpoint, data, options = {}) => {
		const url = requestUtils.buildEndpoint(endpoint, options);
		const requestOptions = {
			endpoint: url,
			args: {
				method: 'DELETE',
				headers: {
					'Content-type': 'application/json'
				},
				body: JSON.stringify(data),
				...(!isProd && { credentials: 'include' })
			}
		};

		return requestUtils.request(requestOptions);
	}
};

export default Request;
